import { memo } from 'react';
import { PriceChartPreview } from './PriceChartPreview';

export default memo(PriceChartPreview);
